import { gql } from "@apollo/client";

export const DELETE_OFFERING = gql`
  mutation deleteOffering($id: String!) {
    deleteOffering(id: $id)
  }
`;
